import { graphql } from 'react-relay';
import { genericMutation, useGenericMutation } from '../utils';
import type { Utils_CreatePostAccessRecipient_Mutation } from './__generated__/Utils_CreatePostAccessRecipient_Mutation.graphql';
import type { Utils_DeletePostAccessRecipient_Mutation } from './__generated__/Utils_DeletePostAccessRecipient_Mutation.graphql';
import type { Utils_RequestPostAccess_Mutation } from './__generated__/Utils_RequestPostAccess_Mutation.graphql';
import type { Utils_UpdatePostAccessRecipient_Mutation } from './__generated__/Utils_UpdatePostAccessRecipient_Mutation.graphql';
import type { Utils_VerifyPostAccess_Mutation } from './__generated__/Utils_VerifyPostAccess_Mutation.graphql';

const RequestPostAccess = graphql`
  mutation Utils_RequestPostAccess_Mutation($input: RequestPostAccessInput!) {
    requestPostAccess(input: $input) {
      clientMutationId
    }
  }
`;

const requestPostAccess = genericMutation<Utils_RequestPostAccess_Mutation>({
  mutation: RequestPostAccess,
});

export const useRequestPostAccess = useGenericMutation<Utils_RequestPostAccess_Mutation>(requestPostAccess);

const VerifyPostAccess = graphql`
  mutation Utils_VerifyPostAccess_Mutation($input: VerifyPostAccessInput!) {
    verifyPostAccess(input: $input) {
      sessionActive
      hasAccess
      uiPermission
    }
  }
`;

const verifyPostAccess = genericMutation<Utils_VerifyPostAccess_Mutation>({
  mutation: VerifyPostAccess,
});

export const useVerifyPostAccess = useGenericMutation<Utils_VerifyPostAccess_Mutation>(verifyPostAccess);

const createPostAccessRecipient = graphql`
  mutation Utils_CreatePostAccessRecipient_Mutation($input: CreatePostAccessRecipientInput!, $connections: [ID!]!) {
    createPostAccessRecipient(input: $input) {
      postAccessRecipient @appendNode(connections: $connections, edgeTypeName: "PostAccessRecipient") {
        ...PostAccess_Recipient_Fragment @relay(mask: false)
      }
    }
  }
`;

const deletePostAccessRecipient = graphql`
  mutation Utils_DeletePostAccessRecipient_Mutation($input: DeletePostAccessRecipientInput!) {
    deletePostAccessRecipient(input: $input) {
      deletedId @deleteRecord
    }
  }
`;

const updatePostAccessRecipient = graphql`
  mutation Utils_UpdatePostAccessRecipient_Mutation($input: UpdatePostAccessRecipientInput!) {
    updatePostAccessRecipient(input: $input) {
      postAccessRecipient {
        ...PostAccess_Recipient_Fragment @relay(mask: false)
      }
    }
  }
`;

export const createPostAccessRecipientMutation = genericMutation<Utils_CreatePostAccessRecipient_Mutation>({
  mutation: createPostAccessRecipient,
});

export const deletePostAccessRecipientMutation = genericMutation<Utils_DeletePostAccessRecipient_Mutation>({
  mutation: deletePostAccessRecipient,
});

export const updatePostAccessRecipientMutation = genericMutation<Utils_UpdatePostAccessRecipient_Mutation>({
  mutation: updatePostAccessRecipient,
});
